import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export default function TooltipWithTable(props) {
    const { t } = props.property;
    return (
        // <CustomWidthTooltip title={tableContent} placement="right" arrow>
        //     <img src="./assets/img/icons/info.png" style={{ width: props.imgwidth, cursor: 'pointer' }} />
        // </CustomWidthTooltip>
        <div class="ticketInfoSecwallet">
            <tr>
                <th >{t('lblbonusname')}</th>
                <th >{t('lblbonusrule')}</th>
                <th >{t('lblremainwager')}</th>
                <th >{t('lblwinbonus')}</th>
                <th >{t('lblSetteledbonus')}</th>
            </tr>
            {props.longText && props.longText.length > 0 && props.longText.map((x1, inx1) =>
                <tr>
                    <td >{x1.bonus_name}</td>
                    <td >{x1.bonus_rule}</td>
                    <td >{x1.remaining_target}</td>
                    <td >{x1.total_bonus}</td>
                    <td >{x1.eligible_withdraw}</td>
                </tr>)}
        </div>
    );
}

// import React from 'react';
// import { Tooltip } from 'react-tooltip';
// import 'react-tooltip/dist/react-tooltip.css';


// export default function TooltipNotes(props) {
//     return (
//         // <Tooltip title={props.longText} style={{ hover: "pointer" }}>
//         //
//         // </Tooltip>
//         <>
//             <img id="my-button" src="./assets/img/icons/info.png" style={{ width: props.imgwidth }} />
//             <div style={{ whiteSpace: "pre-line" }}> <Tooltip anchorId="my-button" content={props.longText} place="bottom" />
//             </div >
//         </>
//     );
// }